import { AnalyseConstants } from '../../_constants';
import { AnalyseService } from '../../_services';

export const analyseActions = {
    getAssessorGroupsHandler,
    saveAssessorGroups,
    saveAssessorIds,

    saveTeamMembers,

    get_team_member_id
}

function getAssessorGroupsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        AnalyseService.getAssessorGroupsHandler(data)
            .then(
                assessorGroups => {

                    const findValueBool = (id) => {
                        let assessorExists = false;

                        for (let i = 0; i < assessorGroups.data.assassessor_groups_for_teamessor_groups_for_team.length; i++) {

                            const assessor = assessorGroups.data.assassessor_groups_for_teamessor_groups_for_team[i];

                            if(assessor.assessor_group__id === id) {
                                assessorExists = true
                                break;
                            }
                            
                        }

                        return assessorExists

                    }

                    const _calculateAge = (birthday, serverTime) => { 
                        var ageDifMs = new Date(serverTime).getTime() - new Date(birthday).getTime();
                        var ageDate = new Date(ageDifMs);
                        return Math.abs(ageDate.getUTCFullYear() - 1970);
                    }
                    


                    const calcAge = (dob) => {
                        // server_time


                        if(dob === null || dob === '') {
                            return 'Not specified'
                        }else {

                            const serverTime = assessorGroups['data']['server_time']

                            if(serverTime) {
                                return _calculateAge(dob, serverTime)
                            }
                            return 'Not specified'
                        }
                    }

                    const getGender = (genderVal) => {
                        if(genderVal === null || genderVal === '') {
                            return 'Not specified'
                        }else {
                            if(genderVal === "1") {
                                return "Male"
                            }else if(genderVal === "2") {
                                return "Female"                                
                            }else if(genderVal === "3") {
                                return "Others"                                
                            }
                        }
                    }

                    const getMaritalStatus = (marital_status) => {
                        if(marital_status === null || marital_status === '') {
                            return 'Not specified'
                        }else {
                            if(marital_status === "1") {
                                return "Single"
                            }else if(marital_status === "2") {
                                return "Married"
                            }else if(marital_status === "3") {
                                return "Divorced"
                            }else if(marital_status === "4") {
                                return "Widow"
                            }
                        }
                    }

                    const checkNullOrEmptyStr = (value) => {
                        if(value === null || value === '') {
                            return 'Not specified'
                        }else {
                            return value
                        }
                    }

                    const checkNullOrEmptyStrChangeToFloat = (value) => {
                        if(value === null || value === '') {
                            return 0
                        }else {
                            return value
                        }
                    }
                    

                    assessorGroups['data']['assessor_groups_for_team'] = assessorGroups.data.organisation_assessor_groups.map(assessor => {
                        return {
                            assessor_name: assessor.assessor_group__assessor_name,
                            id: assessor.assessor_group_id,
                            value: findValueBool(assessor.assessor_group_id)
                        }
                    }).filter(assessor => assessor.value)

                    assessorGroups['data']['team_members_unchanged_copy'] = [...assessorGroups.data.team_members]

                    assessorGroups['data']['team_members'] = assessorGroups.data.team_members.map((member, key) => {
                        return {
                            is_team_leader: assessorGroups.data.team_leader === member.participant__id ? true : false,
                            age: calcAge(member.participant__date_of_birth),
                            filtered: true,
                            relationFilter: true,
                            assessment: {
                                id: checkNullOrEmptyStr(member.id)
                            },
                            user__country__country_name: checkNullOrEmptyStr(member.participant__country__country_name),
                            user__date_of_birth: checkNullOrEmptyStr(member.participant__date_of_birth),
                            user__full_name: member.participant__full_name,
                            user_email: checkNullOrEmptyStr(member.participant__email),
                            user__gender: getGender(member.participant__gender),
                            user_details: [
                                {
                                    annual_income: checkNullOrEmptyStr(member.participant__user_details__annual_income),
                                    city: checkNullOrEmptyStr(member.participant__user_details__city),
                                    designation: checkNullOrEmptyStr(member.participant__user_details__designation),
                                    family_type: checkNullOrEmptyStr(member.participant__user_details__family_type),
                                    industry__demographic_name: checkNullOrEmptyStr(member.participant__user_details__industry__demographic_name),
                                    marital_status: getMaritalStatus(member.participant__user_details__marital_status),
                                    no_of_children: checkNullOrEmptyStr(member.participant__user_details__marital_status),
                                    occupation: checkNullOrEmptyStr(member.participant__user_details__occupation),
                                    qualification__demographic_name: checkNullOrEmptyStr(member.participant__user_details__qualification__demographic_name),
                                    tenure_in_company: checkNullOrEmptyStrChangeToFloat(member.participant__user_details__tenure_in_company),
                                    work_experience: checkNullOrEmptyStrChangeToFloat(member.participant__user_details__work_experience),
                                }
                            ],
                            participant__user_level: checkNullOrEmptyStr(member.participant__user_level),
                            participant__respondent_completed: checkNullOrEmptyStr(member.respondent_completed),
                            lowerCaseUserNames: member.participant__full_name ? member.participant__full_name.toLowerCase() : member.participant__email.toLowerCase()

                        }
                    }).sort((a,b) => {
                        let textA = a.lowerCaseUserNames;
                        let textB = b.lowerCaseUserNames;
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    })

                    dispatch(success(assessorGroups));
                    dispatch(saveTeamMembers(assessorGroups.data.team_members))
                    callback(assessorGroups)
                },
                error => {
                    dispatch(failure(error));
                    callback()
                }
            );
    };

    function request() { return { type: AnalyseConstants.REQUEST_ASSESSOR_GROUPS } }
    function success(assessorGroups) { return { type: AnalyseConstants.RECEIVE_ASSESSOR_GROUPS, assessorGroups } }
    function failure(error) { return { type: AnalyseConstants.ASSESSOR_GROUPS_ERROR, error } }
}

function get_team_member_id(data, callback) {
    return dispatch => {
        dispatch(request());
        AnalyseService.get_team_member_id_api(data)
            .then(
                team_member_ids => {

                    dispatch(success(team_member_ids));

                    callback ? callback(team_member_ids) : null;

                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyseConstants.REQUEST_TEAM_ID_GROUPS } }
    function success(team_member_ids) { return { type: AnalyseConstants.RECEIVE_TEAM_ID_GROUPS, team_member_ids } }
    function failure(error) { return { type: AnalyseConstants.TEAM_ID_GROUPS_ERROR, error } }
}

function saveAssessorGroups(data, callback, relationFilter) {
    return dispatch => {
        dispatch(success(data));
        if(callback) {
            callback(data)
        }
        
        if(relationFilter) {
            dispatch(requestFilter());
        }else {
            dispatch(request());
        }
        

    };
    function request() { return { type: AnalyseConstants.REQUEST_SAVE_ASSESOR_GROUPS } }
    function requestFilter() { return { type: AnalyseConstants.REQUEST_SAVE_ASSESOR_GROUPS, relationFilterUsed: true } }
    function success(data) { return { type: AnalyseConstants.RECEIVE_SAVE_ASSESOR_GROUPS, data } }
}

function saveAssessorIds(data){
    return dispatch => {
        if(data !== '') {
            if(data.assessmentIds.length < 2) {
                dispatch({type: "SINGLE_VALIDATOR"})
            }else {
                dispatch({type: "SINGLE_VALIDATOR_FALSE"})
            }
        }
        dispatch(success(data));
        dispatch(request());

    };
    function request() { return { type: AnalyseConstants.REQUEST_SAVE_ASSESOR_IDS } }
    function success(data) { return { type: AnalyseConstants.RECEIVE_SAVE_ASSESOR_IDS, data } }
}


function saveTeamMembers(data) {
    return dispatch => {
        dispatch(success(data));
        dispatch(request());

    };
    function request() { return { type: AnalyseConstants.REQUEST_SAVE_TEAM_STASH } }
    function success(data) { return { type: AnalyseConstants.RECEIVE_SAVE_TEAM_STASH, data } }
}



// WEBPACK FOOTER //
// ./src/_actions/Analyse/analyse.actions.js